var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAmi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Res_Amazon-EC2_AMI_48 1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(0.712891 0.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-Resource/Compute/Res_Amazon-EC2_AMI_48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Amazon-Containers-AMI_Resource-Icon_light-bg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7844 19.3635H20.0124V13.828H15.7844V19.3635ZM5.32739 19.3635H9.55589V13.828H5.32739V19.3635ZM10.5559 19.3635H14.7844V13.828H10.5559V19.3635ZM20.5124 12.828H4.82739C4.55089 12.828 4.32739 13.052 4.32739 13.328V19.8635C4.32739 20.1395 4.55089 20.3635 4.82739 20.3635H20.5124C20.7884 20.3635 21.0124 20.1395 21.0124 19.8635V13.328C21.0124 13.052 20.7884 12.828 20.5124 12.828ZM15.7844 10.214H20.0124V5.9855H15.7844V10.214ZM5.32739 10.214H9.55589V5.9855H5.32739V10.214ZM10.5559 10.214H14.7844V5.9855H10.5559V10.214ZM20.5124 4.9855H4.82739C4.55089 4.9855 4.32739 5.2095 4.32739 5.4855V10.714C4.32739 10.99 4.55089 11.214 4.82739 11.214H20.5124C20.7884 11.214 21.0124 10.99 21.0124 10.714V5.4855C21.0124 5.2095 20.7884 4.9855 20.5124 4.9855ZM22.6264 20.1895C22.6264 21.416 21.6289 22.4135 20.4029 22.4135H4.93689C3.71039 22.4135 2.71289 21.416 2.71289 20.1895V4.724C2.71289 3.4975 3.71039 2.5 4.93689 2.5H20.4029C21.6289 2.5 22.6264 3.4975 22.6264 4.724V20.1895ZM20.4029 1.5H4.93689C3.15939 1.5 1.71289 2.946 1.71289 4.724V20.1895C1.71289 21.967 3.15939 23.4135 4.93689 23.4135H20.4029C22.1804 23.4135 23.6264 21.967 23.6264 20.1895V4.724C23.6264 2.946 22.1804 1.5 20.4029 1.5Z",
    fill: "#ED7100"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmi);
export default __webpack_public_path__ + "static/media/AMI.ba5484462c912913028b4e5b15039723.svg";
export { ForwardRef as ReactComponent };